export const guaranteesConfig = [
  {
    groupName: 'Терапевтическая стоматология',
    itemList: [
      { title: 'Лечение поверхностного кариеса и некариозных поражений', value: '1 год' },
      { title: 'Лечение среднего кариеса', value: '1 год' },
      { title: 'Лечение глубокого кариеса', value: '1 год' },
      { title: 'Лечение кариеса методом импрегнации', value: '1 год' },
      { title: 'Виниры из композитного материала', value: '1 год' }
    ],
    // TODO: warning cards
    descrtiptions: [
      {
        type: 'info',
        text: 'Гарантия аннулируется при нарушении со стороны пациента графика профилактических осмотров, гигиенических визитов, предусмотренных планом лечения, рекомендаций врача (использование специализированных паст и зубных щеток, очищающих таблеток и т.д.).'
      },
      {
        type: 'warning',
        text: 'При невыполнении рекомендованного плана лечения сроки гарантии и сроки службы не устанавливаются.'
      },
      {
        type: 'info',
        text: 'Замена временного лечебного пломбирования корневых каналов или временной пломбы на постоянную в другом лечебном учреждении не является основанием для предоставления гарантии на лечение со стороны ООО «Стоматологический комплекс-2».'
      }
    ]
  }, {
    groupName: 'Ортопедическая стоматология',
    itemList: [
      { title: 'Цельнолитые', value: '1 год' },
      { title: 'Металлокерамические (любой сплав)', value: '1 год' },
      { title: 'Металлокерамические на имплантате', value: '1 год' },
      { title: 'Из диоксида циркония', value: '1 год' },
      { title: 'Коронки и виниры e-max', value: '1 год' },
      { title: 'Ультратонкие люминиры', value: '2 года' },
      { title: 'Бюгельный протез', value: '1 год' },
      { title: 'Виниры', value: '1 год' },
      { title: 'Съемный пластиночный протез', value: '1 год' }
    ]
  }, {
    groupName: 'Ортодонтия',
    itemList: [
      { title: 'Каппа однослойная', value: '1 год' },
      { title: 'Несъемный ретейнер', value: '1 год' },
      { title: 'Вестибулярная пластинка', value: '1 год' }
    ]
  }
]
